import { useIsAgentHomeV1Enabled } from '@/features/flags';
import {
  ProjectHeaderActions as ProjectHeaderActionsView,
  ProjectHeaderCommonMenuItems as ProjectHeaderCommonMenuItemsView,
  useDeleteProject,
  useToggleSavedProject,
  type ProjectHeaderActionsHost,
  type ProjectHeaderActionsProps,
  type ProjectHeaderCommonMenuItemsProps,
} from '@heidi/agents';
import { useBaseChatHref } from '@heidi/agents/data';
import { useRouter } from 'next/router';

/**
 * The app half of both header shapes: the Delete flag gate, the chat-list
 * mutations and the route back to the chat home.
 */
const useProjectHeaderActionsHost = (): ProjectHeaderActionsHost => {
  const router = useRouter();
  return {
    canDelete: useIsAgentHomeV1Enabled(),
    useToggleSavedProject,
    useDeleteProject,
    homeHref: useBaseChatHref(),
    onNavigate: async (href) => {
      await router.push(href);
    },
  };
};

/** The project detail header's action cluster, bound to the app. */
export const ProjectHeaderActions = (props: ProjectHeaderActionsProps) => {
  const host = useProjectHeaderActionsHost();
  return <ProjectHeaderActionsView {...props} {...host} />;
};

/** The shared chat menu items for the routine-run header, bound to the app. */
export const ProjectHeaderCommonMenuItems = (
  props: ProjectHeaderCommonMenuItemsProps
) => {
  const host = useProjectHeaderActionsHost();
  return <ProjectHeaderCommonMenuItemsView {...props} {...host} />;
};
